import { api } from './base';

export interface SiteInfo {
  name: string;
  title: string;
}

export interface ListSiteInfosResult {
  sites: Array<SiteInfo>;
}

export const siteApis = {
  listSites(name: string) {
    let url = '/sites';
    if (name) {
      url += `?name=${name}`;
    }
    return api.get(url).then(r => r.sites);
  }
};
